import React from 'react';

const Footer = () => {
  return (
    <footer>
        <div class="footer_section space_sec pb-0">
            <div class="container">
                <div class="footer_row d-flex flex-wrap">
                    <div class="footer_col footer_col1">
                        <div class="footer_mune">
                            <h6>Services</h6>
                            <ul>
                                <li><a href="#">Horoscope</a></li>
                                <li><a href="#">Palmistry</a></li>
                                <li><a href="#">Numerology</a></li>
                                <li><a href="#">Kundali</a></li>
                                <li><a href="#">Vastu</a></li>
                                <li><a href="#">Nakshatra</a></li>
                                <li><a href="#">Gemstones</a></li>
                                <li><a href="#">Panchang</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer_col footer_col2">
                        <div class="footer_mune">
                            <h6>Free Report</h6>
                            <ul>
                                <li><a href="#">Kundali</a></li>
                                <li><a href="#">Daily Horoscope</a></li>
                                <li><a href="#">Numerology</a></li>
                                <li><a href="#">Know Your Lucky Number</a></li>
                                <li><a href="#">Sade Sati</a></li>
                                <li><a href="#">Match Making</a></li>
                                <li><a href="#">Puja</a></li>
                                <li><a href="#">Know Your Lucky Colour</a></li>
                                <li><a href="#">Gemstone Suggestion</a></li>
                                <li><a href="#">Daily Panchang</a></li>
                                <li><a href="#">Daily Prediction</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer_col footer_col3">
                        <div class="footer_mune">
                            <h6>Services</h6>
                            <ul>
                                <li><a href="#">Horoscope</a></li>
                                <li><a href="#">Palmistry</a></li>
                                <li><a href="#">Numerology</a></li>
                                <li><a href="#">Kundali</a></li>
                                <li><a href="#">Vastu</a></li>
                                <li><a href="#">Nakshatra</a></li>
                                <li><a href="#">Gemstones</a></li>
                                <li><a href="#">Panchang</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer_col footer_col4">
                        <div class="footer_mune">
                            <h6>Visiting Locations</h6>
                            <ul>
                                <li><a href="#">Mumbai</a></li>
                                <li><a href="#">Gorakhpur</a></li>
                                <li><a href="#">Ghaziabad Uttar Pradesh</a></li>
                                <li><a href="#">Jaipur</a></li>
                                <li><a href="#">Chennai</a></li>
                                <li><a href="#">Chandigarh</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer_col footer_col5">
                        <div class="footer_mune">
                            <h6>Contact</h6>
                            <ul>
                                <li>Head Office : <span>B1-101, Block-E, Classic Residency Apartment, Raj Nagar Extension, Ghaziabad, Uttar Pradesh - 201017</span></li>
                                <li>Mumbai Branch : <span>Shop 2, Floor - Grd, Plot 675/676, Jasota Kutir Chs, Anant Patil Marg, Shivaji Park, Tel Exchange Dadar(W), Mumbai - 400028</span></li>
                                <li>Gorakhpur Branch : <span>Hno 600 D, Shivnagar Colony, Basharatpur, Gorakhpur, Uttar Pradesh - 273004</span></li>
                            </ul>
                            <div class="ss_icons mt-3">
                                <ul class="d-flex align-items-center gap-1">
                                    <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="copyright_sec d-flex align-items-center justify-content-between">
                    <p>Copyright © Kundali Expert &nbsp;|&nbsp; All Rights Reserved</p>
                    <p><a href="#">Privacy Policy</a> &nbsp;|&nbsp; <a href="#">Terms</a></p>
                </div>
            </div>
        </div>
    </footer>
  );
};

export default Footer;